import * as React from 'react'
import { useCallback } from 'react'
import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'
import { ItemClickHandle, View } from '@/components'
import { observer } from 'mobx-react-lite'
import { Button, Col, Empty, EmptyProps, Row } from 'antd'
import Image from 'next/image'
import { ProductDynamicPrice } from './ProductDynamicPrice'
import { Product, ProductVariantOption } from '../stores/ProductModel'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { mixpanelEvent } from '@/lib/mixpanels/mixpanel'
import { DEFAULT_BOOK_COVER } from '@/settings/constant'
// import { STUDIO_VERSION } from '@/modules/products/views/ProductDetailView'

export interface ProductListItemData {
	id: number
	title: string

	product?: Product
}

export type ProductListItemMetadata = {
	action: 'edit' | 'delete'
}

export type ProductListItemOnPriceChange = (product: Product, variant: ProductVariantOption) => void
export type ProductListItemClickHandle = ItemClickHandle<
	ProductListItemData,
	ProductListItemMetadata
>

export interface ProductListProps {
	dataSource: ProductListItemData[]
	onClick: ProductListItemClickHandle
	onPriceChange: ProductListItemOnPriceChange
	onEmptyClick?: () => void
	isAllList?: boolean
	// keyword?: string
	allChecked?: boolean
	selectedItems?: ProductListItemData[]
	onChangeSelectedItems?: (checked: boolean, item: ProductListItemData) => void
	useNewPlan?: boolean
	useParsingBadge?: boolean
}

export const ProductListEmpty: React.FC<{
	title: string
	emptyOptions?: EmptyProps
	onEmptyClick?: () => void
}> = ({ title, emptyOptions, onEmptyClick }) => {
	const handleEmptyClick = useCallback(() => {
		if (onEmptyClick) {
			onEmptyClick()
		}
	}, [onEmptyClick])
	return (
		<Empty {...emptyOptions} description={<span>{title}</span>}>
			<Button type="primary" onClick={handleEmptyClick}>
				새로 만들기
			</Button>
		</Empty>
	)
}

export const ProductListCustomEmpty: React.FC<{
	title: string
	children?: React.ReactNode
	// keyword?: string
	smallType?: boolean
	query?: any
}> = ({ title, children, /*keyword,*/ smallType, query }) => {
	return (
		<ProductListEmptyWrapper smallType={smallType}>
			<EmptyIcon smallType={smallType}>
				<Image src="/static/assets/img_empty.svg" alt={'no data'} width={80} height={50} />
			</EmptyIcon>
			<EmptyTitle smallType={smallType}>
				{/*
				{keyword && (
					<>
						<span>{keyword}</span>에 대한
					</>
				)}{' '}
				*/}
				{title}
			</EmptyTitle>
			{children}
		</ProductListEmptyWrapper>
	)
}
export const ProductListParsedDataEmpty: React.FC<{
	title: string
	children?: React.ReactNode
	smallType?: boolean
}> = ({ title, children, smallType }) => {
	return (
		<ProductParsedDataEmptyWrapper smallType={smallType}>
			<EmptyIcon smallType={smallType}>
				<Image
					src="/static/assets/img-construction-01.png"
					alt={'no data'}
					width={72}
					height={72}
				/>
			</EmptyIcon>
			<EmptyTitle smallType={smallType}>{title}</EmptyTitle>
			<Link
				href={'https://solvook.channel.io/support-bots/70272'}
				target={'_blank'}
				className={'request-btn'}>
				편집 요청하기
			</Link>
		</ProductParsedDataEmptyWrapper>
	)
}

export const ProductListItem: React.FC<{
	item: ProductListItemData
	index: number
	onClick: ProductListItemClickHandle
	onPriceChange: ProductListItemOnPriceChange
	allChecked: boolean
	selectedItems: ProductListItemData[]
	onChangeSelectedItems: (checked: boolean, item: ProductListItemData) => void
	useNewPlan: boolean
	useParsingBadge: boolean
}> = observer(
	({
		selectedItems,
		onChangeSelectedItems,
		allChecked,
		item,
		index,
		onClick,
		onPriceChange,
		useNewPlan,
		useParsingBadge,
	}) => {
		const isChecked =
			selectedItems.findIndex((selectedItem) => selectedItem.id === item.id) > -1 ||
			allChecked
		return (
			<>
				{useParsingBadge && index === 2 && <StudioPromotionBanner />}
				<ProductListItemWrapper>
					<Row align={'middle'}>
						<Col>
							{/*<Checkbox*/}
							{/*	checked={isChecked}*/}
							{/*	onChange={(e) => {*/}
							{/*		// console.log(toJS(item.id),toJS(item.product.id))*/}
							{/*		// console.log(toJS(item.product))*/}
							{/*		const checked = e.target.checked*/}
							{/*		onChangeSelectedItems(checked, item)*/}
							{/*	}}*/}
							{/*	value={item.product.id}>*/}
							<Image
								unoptimized={true}
								src={item.product.thumb_img ?? DEFAULT_BOOK_COVER}
								alt={'thumb'}
								width={60}
								height={72}
							/>
							{/*</Checkbox>*/}
						</Col>
						<Col>
							<Link
								href={`/products/${item.product.id}`}
								className={'detail-btn'}
								target={'_blank'}>
								<div>
									<div className={'title'}>
										{item.product.title}
										{/*{item.product.source_type === 'handout' && (*/}
										{/*	<span className={'amount'}>{item.product.questionNumber}</span>*/}
										{/*)}*/}

										{/* @ts-ignore */}
										{item?.product?.source?.studio_version ===
											'v2' && (
											<>
												<Image
													src={'/static/assets/label-edit.svg'}
													alt={'parsing badge'}
													width={75}
													height={20}
													className={'badge-img w'}
													style={{}}
												/>
												<Image
													src={'/static/assets/label-can-edit.svg'}
													alt={'parsing badge'}
													width={75}
													height={20}
													className={'badge-img m'}
													style={{}}
												/>
											</>
										)}
									</div>
									<span className={'publisher'}>
										{item.product.vendor && (
											<>
												{item.product.vendor}
												<span>|</span>
											</>
										)}
										{item.product.author}
									</span>
								</div>
							</Link>
						</Col>
					</Row>
					<ProductDynamicPrice
						product={item.product}
						onPriceChange={onPriceChange}
						useNewPlan={useNewPlan}
						useParsingBadge={useParsingBadge}
					/>
				</ProductListItemWrapper>
			</>
		)
	},
)

export const StudioPromotionBanner: React.FC<{}> = observer(({}) => {
	return (
		<StudioPromotionBannerWrapper>
			<Link
				href={'https://promotion.solvook.com/lab-home'}
				onClick={() => mixpanelEvent('Studio List Banner Clicked')}
				target={'_blank'}>
				스튜디오 전환율을 높이기 위한 배너
			</Link>
		</StudioPromotionBannerWrapper>
	)
})

export const ProductList: React.FC<ProductListProps> = observer(
	({
		selectedItems,
		onChangeSelectedItems,
		allChecked,
		dataSource,
		onClick,
		onEmptyClick,
		onPriceChange,
		isAllList,
		// keyword,
		useNewPlan,
		useParsingBadge,
	}) => {
		if (dataSource.length <= 0) {
			const router = useRouter()
			const { query } = router

			if (query?.parsing === 'Y') {
				return (
					<ProductListParsedDataEmpty
						title={'선택한 필터값으로는 편집가능한 자료가 없어요.'}
						smallType={false}
					/>
				)
			} else {
				return (
					<ProductListCustomEmpty
						title={'검색 결과가 없습니다.'}
						// keyword={keyword}
						// smallType={isAllList}
						smallType={false}
						query={query}
					/>
				)
			}
		}

		return (
			<>
				{dataSource.map((item, i) => (
					<ProductListItem
						item={item}
						key={item.id}
						index={i}
						onClick={onClick}
						onPriceChange={onPriceChange}
						allChecked={allChecked}
						selectedItems={selectedItems}
						onChangeSelectedItems={onChangeSelectedItems}
						useNewPlan={useNewPlan}
						useParsingBadge={useParsingBadge}
					/>
				))}
				{useParsingBadge && dataSource.length < 3 && <StudioPromotionBanner />}
			</>
		)
	},
)

const ProductListEmptyWrapper = styled.div<{ smallType: boolean }>`
	width: 100%;
	padding: ${({ smallType }) => (smallType ? '20px 0' : '90px 0')};
	text-align: center;
	border-radius: 8px;

	@media (max-width: 1200px) {
		border: none;
	}
	@media (max-width: 768px) {
	}
`

const ProductParsedDataEmptyWrapper = styled(ProductListEmptyWrapper)<{}>`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	min-height: 240px;
	padding: 0;
	border-radius: 0;
	background-color: ${themeGet('background.1', '#F5F8FB')};

	p {
		font-size: 16px;
		line-height: 1.5;
		font-weight: normal;
		color: ${themeGet('text.2', '#5F5F69')};
		margin-top: 16px;
	}

	.request-btn {
		position: relative;
		font-size: 14px;
		font-weight: bold;
		color: ${themeGet('primary.0', '#002FA8')};
		text-decoration: underline;
		padding: 8px 18px 8px 0;
		transition: opacity 0.2s;

		@media (hover: hover) {
			&:hover {
				opacity: 0.7;
			}
		}

		&:after {
			display: block;
			content: '';
			position: absolute;
			top: 50%;
			right: 0;
			width: 16px;
			height: 16px;
			background: url('/static/assets/ico-window-primary.svg') no-repeat 50% 50%;
			background-size: contain;
			transform: translateY(-50%);
		}
	}
`

const EmptyIcon = styled.div<{ smallType: boolean }>`
	img {
		width: ${({ smallType }) => (smallType ? '40px' : '80px')};
		max-width: 104px;
	}
`

const EmptyTitle = styled.p<{ smallType: boolean }>`
	font-size: ${({ smallType }) => (smallType ? '14px' : '14px')};
	font-weight: bold;
	color: ${themeGet('text.3', '#BBBBBF')};
	margin: 8px 0 0;

	span {
		color: ${themeGet('text.0', '#1B1B29')};
	}
`

const ProductListItemWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 12px 16px;
	border: solid 1px #f0f0f0;
	background-color: #fff;

	/*/ 장바구니버튼 없앨때/*/
	.ant-select-single:not(.ant-select-customize-input) {
		pointer-events: none;
	}
	.ant-select-arrow {
		display: none;
	}
	&:not(:nth-last-of-type(1)) {
		margin-bottom: 8px;
	}

	@media (max-width: 1200px) {
		margin: 0 36px;

		&:not(:nth-last-of-type(1)) {
			margin-top: 8px;
			margin-bottom: 8px;
		}
	}
	@media (max-width: 768px) {
		padding: 16px 8px;
		margin: 0 16px;
	}

	.ant-row {
		flex-flow: nowrap;

		.ant-col {
			&:not(:nth-of-type(1)) {
				padding-left: 18px;

				@media (max-width: 410px) {
					flex: 1;
				}
			}

			.detail-btn {
				display: block;
				line-height: 1.5;
				transition: opacity 0.2s;

				&:hover {
					opacity: 0.7;
				}

				.badge-img {
					display: inline-block;
					width: 75px;
					height: 20px;
					border: none;
					margin-left: 8px;
					margin-top: -2px;

					&.m {
						display: none;
						width: 16px;
						height: 16px;
						margin-left: 4px;
					}

					@media (max-width: 1200px) {
						&.w {
							display: none;
						}
						&.m {
							display: inline-block;
						}
					}
				}
			}

			/* # TODO 체크박스 살리면 주석 해제 */
			/*
			.ant-checkbox-wrapper {
				align-items: center;

				span {
					padding: 0;
				}

				.ant-checkbox {
					margin-right: 16px;

					& + span {
						overflow: hidden;
						width: 60px;
						height: 72px;

						img {
							display: block;
							width: 100%;
							height: 100%;
							object-fit: cover;
							border: solid 1px #d9d9d9;
						}
					}
				}
			}
		    */

			/* # TODO 체크박스 살리면 삭제 (s) */
			img {
				display: block;
				width: 60px;
				height: 72px;
				object-fit: cover;
				border: solid 1px #d9d9d9;
			}
			/* # TODO 체크박스 살리면 삭제 (e) */

			.title {
				font-size: 16px;
				font-weight: bold;
				color: ${themeGet('text.0', '#1B1B29')};

				@media (max-width: 768px) {
					font-size: 14px;
				}

				.amount {
					display: inline-block;
					vertical-align: bottom;
					font-size: 10px;
					font-weight: bold;
					color: rgba(27, 27, 41, 0.7);
					padding: 2px 5px;
					margin-left: 4px;
					border-radius: 8px;
					border: solid 1px rgba(27, 27, 41, 0.7);
				}
			}

			.publisher {
				font-size: 14px;
				color: ${themeGet('text.0', '#1B1B29')};
				margin-top: 8px;

				span {
					display: inline-block;
					vertical-align: baseline;
					color: rgba(27, 27, 41, 0.1);
				}
			}
		}
	}

	.title {
		& > a {
			font-size: 16px;
			font-weight: bold;
			line-height: 1.5;
		}
	}

	.publisher {
		display: inline-block;
	}
`

export const ProductIndexPageWrapper = styled(View)`
	padding-top: 24px;
	padding-bottom: 72px;

	@media (max-width: 1200px) {
		border: none;
		padding-top: 0;
		padding-bottom: 48px;
	}
	@media (max-width: 768px) {
		padding-bottom: 32px;
	}
`

export const StudioPromotionBannerWrapper = styled.div`
	width: 100%;
	height: 88px;
	margin-bottom: 8px;
	background-color: #1a1a1a;
	@media (max-width: 500px) {
		height: 64px;
	}
	a {
		display: block;
		width: 100%;
		height: 100%;
		font-size: 0;
		background: url('/static/assets/list-banner-_lab.jpg') no-repeat 50% 50%;
		// background-size: contain;
		background-size: cover;
		transition: opacity 0.2s;

		@media (hover: hover) {
			&:hover {
				opacity: 0.8;
			}
		}
		// 모바일을 위한 이미지 사이즈 조정
		@media (max-width: 500px) {
			background-size: auto 64px;
		}
	}
`
